import { render, staticRenderFns } from "./PlayVideo.vue?vue&type=template&id=4b51e388&scoped=true"
import script from "./PlayVideo.vue?vue&type=script&lang=js"
export * from "./PlayVideo.vue?vue&type=script&lang=js"
import style0 from "./PlayVideo.vue?vue&type=style&index=0&id=4b51e388&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b51e388",
  null
  
)

export default component.exports